import type { RxJsonSchema } from 'rxdb'

/**
 * TaskLabel Document Type (Join table for tasks and labels)
 */
export interface TaskLabelDocument {
  id: string
  envId: string
  taskId: string
  labelId: string
  labelGroupId?: string | null
  isDeleted: boolean

  // Denormalized for convenience
  labelName?: string
  labelColor?: string
  labelGroupName?: string | null

  // Audit fields
  createdOn: number
  createdBy: string
  updatedOn: number
  updatedBy: string
  deletedOn?: number | null
  deletedBy?: string | null

  // RxDB replication metadata
  updatedAt?: number
}

/**
 * RxDB Schema for TaskLabel
 */
export const taskLabelSchema: RxJsonSchema<TaskLabelDocument> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    envId: {
      type: 'string',
      maxLength: 36,
    },
    taskId: {
      type: 'string',
      maxLength: 36,
    },
    labelId: {
      type: 'string',
      maxLength: 36,
    },
    labelGroupId: {
      type: ['string', 'null'],
      maxLength: 36,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },

    // Denormalized fields
    labelName: {
      type: 'string',
      maxLength: 100,
      default: '',
    },
    labelColor: {
      type: 'string',
      maxLength: 20,
      default: '#gray',
    },
    labelGroupName: {
      type: ['string', 'null'],
      maxLength: 100,
    },

    // Audit fields
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },

    // RxDB replication metadata
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
  },
  required: [
    'id',
    'envId',
    'taskId',
    'labelId',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  indexes: [
    'taskId',
    'labelId',
    'envId',
    'updatedOn',
    ['taskId', 'labelId'], // Compound index for duplicate prevention
    ['taskId', 'isDeleted'],
    ['labelId', 'isDeleted'],
  ],
}
